<script>
	// Stores
	import MarketGroupSetStore from '@/Stores/Sport/MarketGroupSetStore.js';
	import CompetitionStore from '@/Stores/Sport/CompetitionStore.js';
	// Components
	import SelectInput from '@/Components/SelectInput.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let competition;

	let marketGroupSetId = competition.market_group_set.id && competition.market_group_set.id.valueOf();

	function onSave() {
		CompetitionStore.updateCompetitionMarketGroupSet(competition.id, marketGroupSetId || null)
			.then(() => {
				notify({
					type: 'success',
					title: 'Competition Updated',
					message: `${competition.name} Updated`,
					timeout: 3
				});
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Failed to update Competition',
					timeout: 5
				});
			});
	}
</script>

<tr class="cursor-pointer hover:bg-gray-100 focus-within:bg-gray-100">
	<td class="w-1/3 p-4 px-6 border-t">
		<div class="flex items-center">
			<div class="mr-2 font-semibold">{competition.name}</div>
		</div>
	</td>
	<td class="p-4 px-6 border-t">
		<SelectInput
			className="py-1 w-1/3"
			name={`competition-${competition.id}`}
			required={true}
			bind:value={marketGroupSetId}
		>
			<option value={false}>Select Market Group Set...</option>
			{#each $MarketGroupSetStore.all() as mgs}
				{#if parseInt(mgs.id) === parseInt(competition.market_group_set.id)}
					<option value={mgs.id} selected>{mgs.name}</option>
				{:else}
					<option value={mgs.id}>{mgs.name}</option>
				{/if}
			{/each}
		</SelectInput>
	</td>
	<td class="w-px px-6 border-t">
		<button on:click={onSave} class="btn btn-black">Save</button>
	</td>
</tr>
